import { getCore } from '../../client/core/getCore';
import type { DynamicClient } from '../../client/types';
import { fetchAndStoreNonces } from './fetchAndStoreNonces/fetchAndStoreNonces';

/**
 * Returns a nonce for wallet ownership verification.
 *
 * Pops the first nonce from the prefetched pool. When the pool is running low
 * (≤1 remaining after pop) a background refetch is triggered. If the pool is
 * empty, nonces are fetched on-demand before returning.
 */
export const getNonce = async (
  client: DynamicClient
): Promise<string> => {
  const core = getCore(client);
  const pool = core.state.get().prefetchedNonces;

  if (pool.length > 0) {
    const [nonce, ...remaining] = pool;

    core.state.set({ prefetchedNonces: remaining });

    if (remaining.length <= 1) {
      void fetchAndStoreNonces(client);
    }

    return nonce;
  }

  await fetchAndStoreNonces(client);

  return getNonce(client);
};
